import { Children, FC, ReactNode } from 'react';
import { useRouter } from 'next/router';

import { Link } from 'routes';

const validateChildren = (children: ReactNode) => {
  if (process.env.NODE_ENV === 'development') {
    try {
      const child = Children.only(children);
      return child;
    } catch (err) {
      throw new Error(
        'Invalid children, see https://nextjs.org/docs/messages/link-multiple-children'
      );
    }
  }
  return Children.only(children);
};

interface Props {
  params: Record<string, string>;
  // passes href to the child, useful for components using React.ForwardRef
  passHref?: boolean;
}

const QueryParamLink: FC<Props> = ({ children, params, passHref }) => {
  // asPath contains pathname and query params
  // query would also contain route parameters
  const { asPath } = useRouter();
  // Add default base URL for Chromatic
  const { pathname, searchParams } = new URL(asPath, process.env.DOMAIN ?? 'https://zehitomo.com');
  const child = validateChildren(children);
  Object.entries(params).forEach(([key, value]) =>
    value ? searchParams.set(key, value) : searchParams.delete(key)
  );

  return (
    <Link
      prefetch={false}
      route={`${pathname}?${searchParams.toString()}`}
      shallow={true}
      passHref={passHref}
    >
      {child}
    </Link>
  );
};

export default QueryParamLink;
